import type { ErrorComponentProps } from "@tanstack/react-router";
import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

/**
 * App-level route error fallback. Without this, ANY route-resolution failure
 * (an uncaught loader/`beforeLoad` error, an aborted navigation) renders an
 * empty DOM — the "white screen of death" (e.g. the June 2026 OAuth redirect
 * loop). A recoverable card is always better than a blank page; "Ricarica"
 * returns to a CLEAN root URL, which also clears any bad query-param state.
 */
export function RouteErrorFallback({ error, reset, preserveLocation = false }: ErrorComponentProps & { preserveLocation?: boolean }) {
  const { i18n } = useLingui();
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-cream px-6 text-center">
      <p className="font-display text-[18px] text-ink-1">
        {i18n._(msg`Qualcosa è andato storto nel caricamento della pagina.`)}
      </p>
      {error?.message ? (
        <p className="max-w-md text-[13px] text-ink-3">{error.message}</p>
      ) : null}
      <button
        type="button"
        onClick={() => {
          reset();
          if (preserveLocation) window.location.reload();
          else window.location.assign("/");
        }}
        className="rounded-md bg-ando-orange px-4 py-2 font-medium text-[14px] text-white transition-colors hover:bg-ando-orange/90"
      >
        {i18n._(msg`Ricarica`)}
      </button>
    </div>
  );
}
